// Extract YouTube video ID from various YouTube URL formats
function extractYouTubeId(url) {
  if (!url) return null;

  // Handle youtu.be short links
  const shortMatch = url.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
  if (shortMatch) return shortMatch[1];

  // Handle full YouTube URLs with v parameter
  const fullMatch = url.match(/(?:youtube\.com\/watch\?v=|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/);
  if (fullMatch) return fullMatch[1];

  // Handle just the video ID
  if (/^[a-zA-Z0-9_-]{11}$/.test(url)) return url;

  return null;
}

export function parseVideoResult(row) {
  if (!row) {
    return {
      videoId: null,
      error: 'No video data provided.',
    };
  }

  const videoLink = row.videoLink?.toString().trim() || row.video?.toString().trim() || '';

  if (!videoLink) {
    return {
      videoId: null,
      error: 'No video link found in the sheet.',
    };
  }

  const videoId = extractYouTubeId(videoLink);

  if (!videoId) {
    return {
      videoId: null,
      error: 'Invalid YouTube URL format.',
    };
  }

  return {
    videoId,
    error: null,
  };
}
